export namespace common {
  export const SYSTEM_NAME = 'V-JIT'
}

export namespace userType {
  export const USER_TYPE_ADMIN = 0
  export const USER_TYPE_FARM_WORKER = 1
  export const USER_TYPE_FARM_ADMIN = 2
  export const USER_TYPE_ALL = 3
}

export namespace routerPath {
  export const PATH_LOGIN = '/login'
  export const PATH_PASSWORD_REMINDER = '/password-reminder'
  export const PATH_PASSWORD_REMINDER_COMPLETE = '/password-reminder/complete'
  export const PATH_PASSWORD_RESETTING = '/password-reminder/:uq_key'
  export const PATH_PASSWORD_RESETTING_COMPLETE = '/password-resetting/complete'
  export const PATH_FIELD = '/field'
  export const PATH_FIELD_DETAILS = '/field/:field_id'
  export const PATH_ACCOUNT_LIST = '/account'
  export const PATH_ACCOUNT_CREATE = '/account/create'
  export const PATH_ACCOUNT_EDIT = 'account/:user_id'
  export const PATH_MY_PAGE = '/mypage'
  export const PATH_ERROR_PAGE = '/error-page'
}

export namespace harvestStatus {
  export const NOT_DIRECTED = 0
  export const ON_HOLD = 1
  export const CHANCEL = 2
  export const HARVESTED = 3
  export const HARVESTING = 4
  export const HARVEST_DONE = 5
}

export namespace plantingSeason {
  export const SPRING = 1
  export const SUMMER = 2
  export const AUTUMN = 3
  export const WINTER = 4
}
